import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { get } from 'lodash';


const ProtectedRoutes = ({ children, ...rest }) => {
  const isLoggedIn = useSelector(state =>
    get(state, 'loginReducer.isLoggedIn', false)
  );
  const isOtp = useSelector(state =>
    get(state, 'loginReducer.data.OTP', false)
  );
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn && !isOtp ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

ProtectedRoutes.propTypes = {
  children: PropTypes.element
};

export default ProtectedRoutes;
